var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgEditIcon = function SvgEditIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#editIcon_svg__clip0_6700_588264)",
    fill: "#333"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 15.333H0V16h16v-.667zM1.998 14a.68.68 0 00.133-.013l2.338-.614a.666.666 0 00.34-.182L15.139 2.862a.667.667 0 000-.943L13.414.195a.663.663 0 00-.943 0L2.143 10.524a.666.666 0 00-.183.34l-.613 2.338a.667.667 0 00.651.798zm.612-2.985l.004-.02L12.942.668h.001l1.724 1.724L4.338 12.719l-.02.004-2.316.609.608-2.317z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "editIcon_svg__clip0_6700_588264"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgEditIcon;